import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
// import { styled } from "@mui/material/styles";
import { Stack } from "@mui/system";
import { useState } from "react";
import { dataToCalc } from "../database/data";
import {
  BASE_SALARY,
  formDetails,
  FORM_FIELDS,
  MANAGERS,
  NO_SOCIAL,
  SCORE_PERCENT,
  SPECIALIST,
  TOOLTIP_TEXT_SPECIALIST,
  URL_SPECIALIST,
} from "../database/formData";
import strings from "../utils/strings";
import ResultCalc from "./ResultCalc";
import TooltipLocal from "./TooltipLocal";
// const useStyles = styled({
//   flexGrow: {
//     flex: "1",
//   },
//   button: {
//     backgroundColor: "#D83155",
//     color: "#fff",
//     "&:hover": {
//       backgroundColor: "#fff",
//       color: "#E02626",
//     },
//   },
// });

function Calculator() {
  const [errors, setErrors] = useState({});
  const [dataForm, setDataForm] = useState({});
  const [calcResult, setCalcResult] = useState({});
  const [specialist, setSpecialist] = useState(false);
  const width = window.innerWidth;
  // const classes = useStyles();

  function clearForm() {
    setSpecialist(false);
    setDataForm({});
    setErrors({});
    setCalcResult({});
  }

  function handleSubmit(event) {
    event.preventDefault();
    let errorsLocal = {};
    const keys = Object.keys(dataForm);
    FORM_FIELDS.forEach((data) => {
      if (
        !keys.includes(data) &&
        formDetails.find((item) => item.name === data).requierd
      ) {
        errorsLocal[data] = true;
      }
    });
    setErrors(errorsLocal);
    if (Object.keys(errorsLocal).length === 0) calc();
  }

  function calc() {
    ///calc study hours
    const studyHours =
      dataForm.studyHours +
      dataToCalc.hoursPerDegree.find(
        (degree) => degree["degree"] === dataForm.degree
      ).hours;

    ///calc referenceTable
    let referenceTable = {};

    //calc x2
    dataForm.degree !== "תואר ראשון"
      ? (referenceTable.x2 = 2)
      : (referenceTable.x2 = 0);

    //calc x3

    referenceTable.x3 = dataToCalc.levelPerCompletion.find(
      (level) => level.min <= studyHours && level.max > studyHours
    ).level;

    //calc x4
    referenceTable.x4 = Math.max(referenceTable.x2, referenceTable.x3);

    //calc x5
    referenceTable.x5 = dataToCalc.levelPerTime.find(
      (level) =>
        level.min <= dataForm.professionalSeniority &&
        level.max > dataForm.professionalSeniority
    ).level;

    //calc  professional level
    let professionalLevel;
    if (dataForm.specialist) {
      professionalLevel = SPECIALIST;
    } else {
      professionalLevel = dataToCalc.ranks.find(
        (rank) => rank.rank === Math.min(referenceTable.x5, referenceTable.x4)
      ).label;
    }

    // calc score administrative professional
    const scoreAdministrativeProfessional =
      SCORE_PERCENT *
      dataToCalc.managementLevels.find(
        (level) => level.level === dataForm.managerLevel
      )[dataToCalc.translation[professionalLevel]];

    // calc base salary
    const baseSalary = (BASE_SALARY * dataForm.jobPercentage) / 100;

    // calc administrative professional addition
    const administrativeProfessionalAddition =
      (baseSalary * scoreAdministrativeProfessional) / 100;

    // calc basic salary
    const basicSalary = baseSalary + administrativeProfessionalAddition;

    // calc seniority salary addition
    const senioritySalaryAddition =
      basicSalary *
      (dataToCalc.seniority.find(
        (year) => year.years === dataForm.senioritySalary
      ).perLessOne /
        100);

    let additionalWorkLawLevel = 0;
    if (dataForm.managerLevel < 4) {
      additionalWorkLawLevel = dataToCalc.addiitionToShekelLaw.find(
        (job) => job.level === dataForm.lawSupplement
      ).increase;
    } else {
      if (dataForm.lawSupplement === NO_SOCIAL) {
        additionalWorkLawLevel =
          dataToCalc.addiitionToShekelLaw.find(
            (level) => level.level === NO_SOCIAL
          ).increase;
      } else {
        additionalWorkLawLevel =
          dataToCalc.addiitionToShekelLaw.find(
            (level) => level.level === MANAGERS
          ).increase;
      }
    }

    const supplementFrameworkAgreement = (400 * dataForm.jobPercentage) / 100

    let oldField = dataForm.jobPercentage
    let newField = dataForm.jobPercentageBySocialLow

    let additionalWorkVirtueAppointmentLawPercent = 0
    if (oldField < 50) {
      additionalWorkVirtueAppointmentLawPercent = oldField
    } else {
      if (newField >= oldField) {
        additionalWorkVirtueAppointmentLawPercent = oldField
      } else if (newField >= 50) {
        additionalWorkVirtueAppointmentLawPercent = newField
      } else {
        additionalWorkVirtueAppointmentLawPercent = 50
      }
    }

    const additionalworkVirtueAppointmentLaw =
        (additionalWorkLawLevel * additionalWorkVirtueAppointmentLawPercent) / 100;


    //calc total salary
    const totalSalary =
        basicSalary +
        supplementFrameworkAgreement +
        senioritySalaryAddition +
        additionalworkVirtueAppointmentLaw;

    setCalcResult({
      ...calcResult,
      studyHours,
      professionalLevel,
      scoreAdministrativeProfessional,
      baseSalary,
      administrativeProfessionalAddition,
      basicSalary,
      senioritySalaryAddition,
      additionalworkVirtueAppointmentLaw,
      supplementFrameworkAgreement,
      totalSalary,
    });
  }

  return (
    <>
      <Grid
        container
        direction="row-reverse"
        sx={{
          backgroundColor: "#F2F2F3",
          paddingX: "4%",
          paddingY: width < 580 ? "12%" : "4%",
        }}
      >
        <Grid item xs={12} md={6} paddingBottom={2}>
          <form onSubmit={handleSubmit}>
            <Stack
              spacing={2.5}
              sx={{
                backgroundColor: "#FFFFFF",
                paddingX: "10%",
                marginBottom: width < 580 ? "10%" : "0%",

                borderRadius: 4,
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{
                  direction: "rtl",
                  backgroundColor: "#4C1B72",
                  borderBottomLeftRadius: 25,
                  borderBottomRightRadius: 25,
                  paddingY: "2%",
                  color: "white",
                  marginBottom: "8%",
                }}
              >
                {strings.personalParameters}
              </Typography>
              {formDetails.map((field) => {
                return (
                  <Grid
                    container
                    justifyContent="center"
                    direction="row-reverse"
                    key={field.name}
                  >
                    <Grid
                      item
                      alignSelf="center"
                      sx={{
                        marginLeft: "2%",
                        minWidth: 170,
                        direction: "rtl",
                      }}
                    >
                      <Typography variant="h6">{field.label}</Typography>
                    </Grid>
                    <Grid item>
                      <Stack direction="row-reverse">
                        <TextField
                          sx={{ minWidth: 250 }}
                          size="small"
                          type={field.isNumber ? "number" : "text"}
                          select={field.isSelect}
                          value={
                            Object.keys(dataForm).length > 0 && field.isNumber
                              ? dataForm[field.name]
                              : String(dataForm[field.name])
                          }
                          error={errors[field.name]}
                          placeholder={field.placeHolder}
                          onChange={(event) => {
                            setDataForm({
                              ...dataForm,
                              [field.name]: field.isNumber
                                ? Number(event.target.value)
                                : event.target.value,
                            });
                            setErrors({ ...errors, [field.name]: undefined });
                          }}
                          InputProps={{ inputProps: { min: 0 } }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        >
                          {field.isSelect &&
                            field.options.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                        </TextField>
                        <TooltipLocal text={field.tooltip} url={field.url} />
                      </Stack>
                    </Grid>
                  </Grid>
                );
              })}
              <Grid container justifyContent="center" direction="row-reverse">
                <Grid item alignSelf="center">
                  <Typography variant="h6">{strings.isSpecialist}</Typography>
                </Grid>
                <Grid item>
                  <Checkbox
                    onChange={() => {
                      setDataForm({
                        ...dataForm,
                        specialist: !specialist,
                      });
                      setSpecialist(!specialist);
                    }}
                    style={{ color: "#4C1B72" }}
                    checked={specialist}
                  />
                </Grid>
                <TooltipLocal
                  text={TOOLTIP_TEXT_SPECIALIST}
                  url={URL_SPECIALIST}
                />
              </Grid>
              <Grid
                container
                justifyContent="center"
                direction="row-reverse"
                sx={{
                  paddingTop: "1%",
                  paddingBottom: "9%",
                  borderRadius: 40,
                }}
              >
                <Button
                  sx={{
                    borderRadius: 40,
                    backgroundColor: "#4C1B72",
                    "&:hover": {
                      backgroundColor: "#4C1B7231",
                      color: "#4C1B72",
                    },
                  }}
                  variant="contained"
                  type="submit"
                >
                  {strings.calc}
                </Button>
                <Button
                  sx={{
                    borderRadius: 40,
                    marginRight: 5,
                    color: "#4C1B72",
                    border: "1px solid #4C1B72",
                  }}
                  variant="outlined"
                  onClick={() => clearForm()}
                >
                  {strings.clear}
                </Button>
              </Grid>
            </Stack>
          </form>
        </Grid>
        <Grid item xs={12} md={6}>
          <ResultCalc calcResult={calcResult} />
        </Grid>
      </Grid>
    </>
  );
}

export default Calculator;
